import Rotator from "../helpers/Rotator";

$(document).ready(function () {
    if ($('#rotator').length) {
        Rotator.get('#rotator');
    }
});